import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AppSettings } from 'src/app/app-settings';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PanelAdminService } from 'src/app/services/panel-admin.service';
import { ReportsService } from 'src/app/services/reports.service';
import { ShoppingCartService } from 'src/app/services/shopping-cart.service';
import { QrCardComponent } from '../../bloques/qr-card/qr-card.component';
import { InfoTicketComponent } from '../../totem/info-ticket/info-ticket.component';

@Component({
  selector: 'app-confirm-pay-totem',
  templateUrl: './confirm-pay-totem.component.html',
  styleUrls: ['./confirm-pay-totem.component.scss']
})
export class ConfirmPayTotemComponent implements OnInit {

  idDownload!: any;
  error!: string;

  method: string = 'phone';
  methodUser: string = '';

  public progress = 0;
  public counter = 30;
  public tick = 0;
  public seconds = 30;

  waiting: boolean = true;
  intervalId: any;

  hash: string = '';

  constructor(private dialog: MatDialog, @Optional() @Inject(MAT_DIALOG_DATA) public data, private router: Router, private auth: AuthenticationService,
    private panelService: PanelAdminService, private dialogRef: MatDialogRef<ConfirmPayTotemComponent>, private reportService: ReportsService,
    private sanitizer: DomSanitizer, private shoppingCartService: ShoppingCartService) { }

  ngOnInit(): void {
    this.idDownload = this.data?.order;
    this.method = this.data?.method;
    this.methodUser = this.data?.methodUser || '';
    this.reportService.getUrlsDownload(this.idDownload).subscribe({
      next: (res) => {
        this.hash = res?.data?.ticket_a4 || String(this.idDownload);
      }, error: (err) => {
        this.hash = String(this.idDownload);
      }
    })

    setTimeout(() => {
      this.intervalId = setInterval(() => {
        this.counter = this.counter - 1;
        this.seconds = this.counter;
        if (this.seconds % 10)
          this.tick = this.tick + 1;
        if (this.counter === 0) {
          clearInterval(this.intervalId);
          this.goHome();
        }
      }, 1000)
    }, 5000);
  }

  goHome() {
    // Limpiar el carrito y notificar a los componentes suscritos (incluyendo el header del tótem)
    this.shoppingCartService.setModifyCart(true);
    this.router.navigate(['/home-totem']);
    this.dialog.closeAll();
  }

  // sendWhatsapp() {
  //   const payload = {
  //     order: this.idDownload,
  //     phone: +this.numWhatsapp,
  //   };
  //   this.reportService.sendWhatsappMessage(payload).subscribe({
  //     next: (response) => {
  //       this.checkWhatsapp = true;
  //     },
  //     error: (err) => {
  //       console.error('Error al enviar mensaje de WhatsApp:', err);
  //     }
  //   });
  // }

}
